import { Global } from "@emotion/react";
import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import useResponsive from "../../../Hooks/useResponsive";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import { Autocomplete, Box, Paper, Stack, TextField } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getCRMLists,
  getCRMViewCRODatas,
  getCROLists,
} from "../../../redux/features/CRDslice";
import { useSelector } from "react-redux";
import GlobalMultiSelect from "../../../components/mui/GlobalMultiSelect";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { crmViewTableHeader } from "../../../components/datagrid/myworkspace/crd/crmViewTableHeader";
import TotalCountDisplay from "./TotalCountDisplay";

const CRMView = () => {
    const navigate = useNavigate('')
  const dispatch = useDispatch();
  const { loading, crmLists, croList, croDatas } = useSelector(
    (store) => store.crd
  );
  const [direction, setDirection] = useState("row");
  const smDown = useResponsive("down", "sm");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const crmIdParam = searchParams.get("crmId");
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;
  const [crmId, setCrmId] = useState(
    crmIdParam ? crmIdParam : userProfile.userId
  );
  const [selectedCROS, setSelectedCROS] = useState([]);
  const fromDateParam = searchParams.get("fromDate");
  const toDateParam = searchParams.get("toDate");
  const [fromDate, setFromDate] = useState(
    fromDateParam || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    toDateParam || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  useEffect(() => {
    if (smDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [smDown]);

  const dispatchParams = {
    fromDate,
    toDate,
    crmId,
    selectedCROS,
    paginationData,
  };
  useEffect(() => {
    dispatch(getCRMLists());
  }, []);

  useEffect(() => {
    dispatch(getCROLists(crmId));
  }, [crmId]);

  useEffect(() => {
    if(paginationData?.pageNum){
      dispatch(getCRMViewCRODatas(dispatchParams));
    }
  }, [fromDate, toDate, crmId, selectedCROS, gridSize, pageNum, search]);

  const handleCrmChange = (e, option) => {
    setCrmId(option?.userID);
  };
  return (
    <GlobalWrapper title={"CRM Assessment Report"}>
      <Box>
        <Stack gap={1} direction={direction}>
          <Box>
            <FromAndToDatePicker
              disabled={false}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
            />
          </Box>
          {false && ( //WE CAN ENABLE WHEN PM LOGINS
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                fullWidth
                name="crmId"
                options={crmLists}
                getOptionLabel={(option) => option.name || ""}
                value={crmLists?.find((sogo) => sogo?.userID == crmId) || null}
                onChange={handleCrmChange}
                renderInput={(params) => (
                  <TextField
                    disabled
                    fullWidth
                    autoComplete="off"
                    {...params}
                    label="CRM"
                  />
                )}
              />
            </Box>
          )}
          <Box sx={{ flex: 1 }}>
            <GlobalMultiSelect
              sx={{ minWidth: "100%" }}
              disabled={loading}
              label={"CRO Filter"}
              fullWidth={smDown ? true : false}
              arrayState={selectedCROS}
              arraySetState={setSelectedCROS}
              data={croList}
              keys={{ id: "userId", value: "name" }}
            />
          </Box>
        </Stack>
      </Box>
      <Box my={1}>
        <TotalCountDisplay
          totalStudents={croDatas.data?.headData?.totalStudentsTotal}
          totalCourses={croDatas.data?.headData?.totalCoursesTotal}
          assignedStudents={croDatas.data?.headData?.totalAssignedStudentsTotal}
          unAssignedStudents={croDatas.data?.headData?.totalUnAssignedStudentsTotal}
        />
      </Box>
      <Box>
        <Paper elevation={1}>
          <GlobalDatagrid
            tableHead={crmViewTableHeader(navigate, fromDate, toDate)}
            rows={croDatas.data?.userData || []}
            meta={croDatas?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={false}
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default CRMView;
